(($) => {
  $(document).ready(() => {
    $("#billing_postcode").blur(function() {
        var cep = $(this).val().replace(/\D/g, '');

        if (cep != '' && /^[0-9]{8}$/.test(cep)) {
            $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
                if (!("erro" in dados)) {
                  //Atualiza os campos com os valores da consulta.
                  $("#billing_address_1").val(dados.logradouro);
                  $("#billing_neighborhood").val(dados.bairro);
                  $("#billing_city").val(dados.localidade);
                  $("#billing_state").val(dados.uf);
                  $("#billing_state").trigger('change');
                }
            });
        }
    });
    $("#shipping_postcode").blur(function() {
        var cep = $(this).val().replace(/\D/g, '');

        if (cep != '' && /^[0-9]{8}$/.test(cep)) {
            $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
                if (!("erro" in dados)) {
                  //Atualiza os campos com os valores da consulta.
                  $("#shipping_address_1").val(dados.logradouro);
                  $("#shipping_neighborhood").val(dados.bairro);
                  $("#shipping_city").val(dados.localidade);
                  $("#shipping_state").val(dados.uf);
                  $("#shipping_state").trigger('change');
                }
            });
        }
    });
  })
})(jQuery)
